// DOMContentLoadedを待ってから処理を開始
document.addEventListener('DOMContentLoaded', function() {
  
  // スクロールアップを実行する関数
  function scrollToTop() {
    // モバイルのみで動作
    if (window.innerWidth <= 749) {
      setTimeout(() => {
        const mediaWrapper = document.querySelector('.product__media-wrapper, .pmslider-root, .product__column-sticky');
        if (mediaWrapper) {
          mediaWrapper.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100); // 少し遅延を長くして確実に動作させる
    }
  }

  // イベント委譲を使用してdocument.bodyにリスナーを設定
  document.body.addEventListener('change', function(event) {
    const target = event.target;
    
    // カラーバリアントのinputかどうかを確認
    if (target.matches('input[type="radio"]')) {
      // 親のfieldsetを取得
      const fieldset = target.closest('fieldset.product-form__input');
      
      if (fieldset) {
        const legend = fieldset.querySelector('legend');
        
        // legendに「色」が含まれているか確認
        if (legend && legend.textContent.includes('色')) {
          scrollToTop();
        }
      }
    }
  });

  // clickイベントも同様に委譲
  document.body.addEventListener('click', function(event) {
    const target = event.target;
    const label = target.closest('label');
    
    if (label) {
      const fieldset = label.closest('fieldset.product-form__input');
      
      if (fieldset) {
        const legend = fieldset.querySelector('legend');
        
        if (legend && legend.textContent.includes('色')) {
          scrollToTop();
        }
      }
    }
  });
  
});
// カートボタン補助 sticky-buy-button のスクロール制御
document.addEventListener('DOMContentLoaded', function() {
  const stickyBtn = document.getElementById('custom-sticky-button');
  const footer = document.querySelector('footer');
  const originalCartBtn = document.querySelector('button[name="add"], .product-form__submit');

  if (!stickyBtn) return;

  // --- 1. クリックイベント：元のボタンまで戻る ---
  // --- 1. クリックイベント：元のボタンまで戻る ---
  stickyBtn.addEventListener('click', function(e) {
    if (originalCartBtn) {
      e.preventDefault();
      
      const productTitle = document.querySelector('.product__title, h1');
      let offsetPosition;

      if (productTitle) {
        // 商品名の要素がある場合：その場所を基準にする
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = productTitle.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        
        // スマホ(749px以下)なら 10px、PCなら 80px の余白を持たせる
        const extraMargin = window.innerWidth <= 749 ? 10 : 90;
        
        offsetPosition = elementPosition - extraMargin; 
      } else {
        // 万が一、商品名が見つからない場合の予備設定
        const offset = window.innerWidth <= 749 ? 400 : 300;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = originalCartBtn.getBoundingClientRect().top;
        offsetPosition = (elementRect - bodyRect) - offset;
      }

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });

  // --- 2. スクロールイベント：表示・非表示の切り替え ---
  window.addEventListener('scroll', function() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const footerTop = footer ? footer.offsetTop : document.documentElement.scrollHeight;

    // ★追加：元のボタンが画面内に少しでも見えているか判定
    let isOriginalBtnVisible = false;
    if (originalCartBtn) {
      const rect = originalCartBtn.getBoundingClientRect();
      // ボタンが画面内（上端より下、かつ下端より上）にあるか
      isOriginalBtnVisible = (rect.top < windowHeight && rect.bottom > 0);
    }

    // 表示条件：700px以上スクロール かつ 元のボタンが画面外 かつ フッター手前
    const isScrolledPast = scrollY > 700;
    const isBeforeFooter = (scrollY + windowHeight) < (footerTop - 500);

    // 「元のボタンが見えていない」という条件を必須にする
    if (isScrolledPast && isBeforeFooter && !isOriginalBtnVisible) {
      stickyBtn.classList.remove('sticky-button-hidden');
      stickyBtn.classList.add('sticky-button-visible');
    } else {
      stickyBtn.classList.remove('sticky-button-visible');
      stickyBtn.classList.add('sticky-button-hidden');
    }
  });
});
// ★問い合わせ、お気に入りボタンの設定
document.addEventListener('DOMContentLoaded', function() {
  const wishlistBtn = document.querySelector('.xb-wishlist-button-wrapper');
  
  if (wishlistBtn) {
    // 1. コンテナ（親枠）を作成
    const container = document.createElement('div');
    container.className = 'custom-action-group';
    
    // 2. お問い合わせボタンを作成
    const inquiryBtn = document.createElement('a');
    inquiryBtn.href = `/pages/contact?product_name=${encodeURIComponent(document.title)}`;
    inquiryBtn.className = 'btn-inquiry-fixed';
    inquiryBtn.innerText = '商品お問い合わせ';
    
    // 3. 配置換え：お気に入りの位置にコンテナを置き、その中に両方入れる
    wishlistBtn.parentNode.insertBefore(container, wishlistBtn);
    container.appendChild(inquiryBtn);
    container.appendChild(wishlistBtn);
  }
});

// custom.js
function toggleScrollHeader() {
  const header = document.querySelector('.header-wrapper');
  // 告知バーと検索窓が隠れる程度の高さ（100px前後。実際の表示に合わせて調整してください）
  const scrollThreshold = 100; 

  window.addEventListener('scroll', () => {
    if (window.scrollY > scrollThreshold) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }, { passive: true });
}

document.addEventListener('DOMContentLoaded', toggleScrollHeader);

// ヘッダー下区切り線のスクロール連動表示
(function() {
  function updateHeaderBorder() {
    const header = document.querySelector('.section-header, .header-wrapper, #shopify-section-header');
    if (!header) return;

    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollY > 300) {
      header.style.setProperty('border-bottom', '1px solid #e5e5e5', 'important');
      header.style.boxShadow = 'none';
    } else {
      header.style.setProperty('border-bottom', 'none', 'important');
      header.style.boxShadow = 'none';
    }
  }

  window.addEventListener('scroll', updateHeaderBorder, { passive: true });
  window.addEventListener('resize', updateHeaderBorder);
  updateHeaderBorder();
})();
(function() {
  var isSlidePage = document.body.classList.contains('is-homepage');

  function updateHeaderBorder() {
    var header = document.querySelector('.section-header, .header-wrapper, #shopify-section-header');
    if (!header) return;

    var scrollY = window.pageYOffset || document.documentElement.scrollTop;

    if (!isSlidePage || scrollY > 300) {
      header.style.setProperty('border-bottom', '1px solid #e5e5e5', 'important');
      header.style.boxShadow = 'none';
    } else {
      header.style.setProperty('border-bottom', 'none', 'important');
      header.style.boxShadow = 'none';
    }
  }

  window.addEventListener('scroll', updateHeaderBorder, { passive: true });
  window.addEventListener('resize', updateHeaderBorder);
  updateHeaderBorder();
})();

/* =======================================================
   商品ページ：バリエーション（ホバー時のテキスト切り替え）
   ※ クリック直後の非表示バグ（AJAX再描画）を修正した最終完成版
   ======================================================= */
function initVariantHover() {
  // 1. 選択中の値でラベルを更新する共通関数
  function restoreCheckedValue(fieldset) {
    const legend = fieldset.querySelector('.form__label');
    const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
    if (legend && checkedRadio) {
      // 元のテキスト（「サイズ」や「色」）を保存しておく
      let prefix = legend.dataset.prefix;
      if (!prefix) {
        prefix = legend.innerText.split(':')[0].trim();
        legend.dataset.prefix = prefix;
      }
      // テキストを確実に戻す
      legend.innerText = `${prefix}: ${checkedRadio.value}`;
    }
  }

  // 2. ページ読み込み時に一度実行して初期値をセット
  document.querySelectorAll('.product-form__input').forEach(restoreCheckedValue);

  // 3. ホバー（マウスが乗った時）の処理
  document.addEventListener('mouseover', function(event) {
    const label = event.target.closest('.product-form__input label');
    if (!label) return;
    const fieldset = label.closest('fieldset');
    const legend = fieldset.querySelector('.form__label');
    if (!legend) return;

    if (!legend.dataset.prefix) {
      legend.dataset.prefix = legend.innerText.split(':')[0].trim();
    }

    const radioId = label.getAttribute('for');
    const radio = document.getElementById(radioId);
    if (radio) {
      legend.innerText = `${legend.dataset.prefix}: ${radio.value}`;
    }
  });

  // 4. マウスが離れた時の処理
  document.addEventListener('mouseout', function(event) {
    const label = event.target.closest('.product-form__input label');
    if (!label) return;
    
    // ラベル内の文字などにマウスが動いただけの場合は無視する
    if (label.contains(event.relatedTarget)) return;

    const fieldset = label.closest('fieldset');
    restoreCheckedValue(fieldset);
  });

  // 5. サイズ選択（クリック）直後の処理
  document.addEventListener('change', function(event) {
    if (event.target.type === 'radio' && event.target.closest('.product-form__input')) {
      const fieldset = event.target.closest('fieldset');
      restoreCheckedValue(fieldset);
    }
  });

  // 6. 監視カメラ（MutationObserver）の設置
  // Shopify特有の「裏側でのHTML自動書き換え」が発生した瞬間にテキストを復元する
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // 新しく読み込まれたパーツの中にバリエーション枠があればテキストを復元
            if (node.classList && node.classList.contains('product-form__input')) {
              restoreCheckedValue(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('.product-form__input').forEach(restoreCheckedValue);
            }
          }
        });
      }
    });
  });

  // ページ全体の変化を監視スタート
  observer.observe(document.body, { childList: true, subtree: true });
}

// スクリプトの実行タイミングを最適化して起動
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVariantHover);
} else {
  initVariantHover();
}

(function () {
  window._variantData = [];

  function fetchVariants() {
    const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    if (!handle) return;
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        window._variantData = product.variants;
        updateSizeAvailability();
      });
  }

  function updateSizeAvailability() {
    if (!window._variantData.length) return;

    const colorInput = [...document.querySelectorAll('input[type="radio"]')]
      .find(el => el.name.trim() === '色-2' && el.checked);
    if (!colorInput) return;
    const selectedColor = colorInput.value;

    const sizeAvailability = {};
    window._variantData.forEach(variant => {
      const parts = variant.title.split(' / ');
      if (parts.length < 2) return;
      const variantSize = parts[0].trim();
      const variantColor = parts[1].trim();
      if (variantColor === selectedColor) {
        if (sizeAvailability[variantSize] === undefined) {
          sizeAvailability[variantSize] = false;
        }
        if (variant.available) {
          sizeAvailability[variantSize] = true;
        }
      }
    });

    const sizeInputs = [...document.querySelectorAll('input[type="radio"]')]
      .filter(el => el.name.trim() === 'サイズ-1');

    sizeInputs.forEach(input => {
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (!label) return;
      if (sizeAvailability[input.value] === false) {
        label.classList.add('sold-out-size');
      } else {
        label.classList.remove('sold-out-size');
      }
    });
  }

  function delayedUpdate() {
    setTimeout(updateSizeAvailability, 100);
    setTimeout(updateSizeAvailability, 300);
    setTimeout(updateSizeAvailability, 600);
  }

  // カラー・サイズ変更時に実行
  document.addEventListener('change', function (e) {
    const name = e.target.name.trim();
    if (name === '色-2' || name === 'サイズ-1') {
      delayedUpdate();
    }
  });

  // URL変化（variant切り替え）を監視して実行
  let lastUrl = location.href;
  new MutationObserver(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(updateSizeAvailability, 100);
      setTimeout(updateSizeAvailability, 300);
      setTimeout(updateSizeAvailability, 600);
    }
  }).observe(document, {subtree: true, childList: true});

  // 初期読み込み
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchVariants);
  } else {
    fetchVariants();
  }

  setTimeout(fetchVariants, 1000);
  setTimeout(fetchVariants, 2000);
})();
// 検索結果を商品のみに絞り込む
document.querySelectorAll('form[action="/search"]').forEach(function(form) {
  var input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'type';
  input.value = 'product';
  form.appendChild(input);
});

/* ==========================================
   Swiper カスタムスライダーの実行
   ========================================== */
function initSwiperSlider() {
  if (typeof Swiper !== 'undefined') {
    const swiperContainer = document.querySelector('.myCustomSwiper');
    if (swiperContainer) {
      if (swiperContainer.swiper) {
        swiperContainer.swiper.destroy(true, true);
      }
      new Swiper('.myCustomSwiper', {
        loop: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        speed: 600,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // ①および④ 画面サイズごとの隙間設定
        breakpoints: {
          // スマホ表示（0px以上）
          0: {
            spaceBetween: 0 // スマホは画面幅いっぱいなので隙間なし
          },
          // PC表示（750px以上）
          750: {
            spaceBetween: 10 // PCでの画像と画像の隙間（数値を変更して微調整可能）
          }
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', initSwiperSlider);
document.addEventListener('shopify:section:load', initSwiperSlider);
